import { formatMoney } from '../lib/money';

function getSelectedAddonPrice(): number {
  let total = 0;
  document.querySelectorAll<HTMLInputElement>('.variant-addon-container input[data-variant-addon-option="true"]:checked').forEach((input) => {
    if (input.dataset.price && input.value !== 'null') {
      total += parseInt(input.dataset.price, 10);
    }
  });
  return total;
}

function updateAllKitCardPrices(): void {
  const addonPrice = getSelectedAddonPrice();
  document.querySelectorAll<HTMLElement>('.kit-card').forEach((card) => {
    const totalPrice = parseInt(card.dataset.kitTotalPrice ?? '0', 10);
    const fullPrice = card.dataset.kitFullPrice ? parseInt(card.dataset.kitFullPrice, 10) : null;

    if (fullPrice !== null) {
      const priceEls = card.querySelectorAll<HTMLElement>('.kit-card--price');
      if (priceEls[0]) priceEls[0].textContent = formatMoney(fullPrice + addonPrice);
      const strikeEl = card.querySelector<HTMLElement>('.kit-card--price s');
      if (strikeEl) strikeEl.textContent = formatMoney(totalPrice + addonPrice);
    } else if (totalPrice > 0) {
      const priceEl = card.querySelector<HTMLElement>('.kit-card--price');
      if (priceEl) priceEl.textContent = formatMoney(totalPrice + addonPrice);
    }
  });
}

function calculateKitPoints(priceInCents: number): number {
  let points = priceInCents / 100;
  if (String(priceInCents % 100).padStart(2, '0') !== '00') points += 1;
  return Math.trunc(points) * 10;
}

function updateKitPriceDisplay(priceInCents: number): void {
  const atcPriceEl = document.querySelector<HTMLElement>('.atc-button-price');
  if (atcPriceEl) atcPriceEl.textContent = formatMoney(priceInCents);

  const points = calculateKitPoints(priceInCents);

  const mentionStrong = document.querySelector<HTMLElement>('.mention-content-text strong');
  if (mentionStrong) mentionStrong.textContent = `${points} points.`;

  const rewardEm = document.querySelector<HTMLElement>('.km-reward-mention em');
  if (rewardEm) rewardEm.textContent = `${points} points`;
}

function updateFromCheckedKitRadio(): void {
  const checkedRadio = document.querySelector<HTMLInputElement>('.kit-card input[type="radio"]:checked');
  if (!checkedRadio) return;
  const kitCard = checkedRadio.closest<HTMLElement>('.kit-card');
  if (!kitCard) return;
  const price = parseInt(kitCard.dataset.kitPrice ?? '0', 10);
  if (price) updateKitPriceDisplay(price + getSelectedAddonPrice());
}

function doKitAddToCart(evt: Event, kitCard: HTMLElement, productForm: HTMLElement, submitButton: HTMLButtonElement): void {
  const variantInput = productForm.querySelector<HTMLInputElement>('[name=id]');
  const mainVariantId = variantInput?.value || kitCard.dataset.currentVariant;
  const product1VariantId = kitCard.dataset.p1MatchVariant || kitCard.dataset.p1;
  const product2VariantId = kitCard.dataset.p2MatchVariant || kitCard.dataset.p2;
  const product3VariantId = kitCard.dataset.p3MatchVariant || kitCard.dataset.p3;
  const cart = document.querySelector<HTMLElement>('cart-drawer') || document.querySelector<HTMLElement>('cart-notification');

  submitButton.setAttribute('aria-disabled', 'true');
  submitButton.classList.add('loading');
  productForm.querySelector<HTMLElement>('.loading__spinner')?.classList.remove('hidden');

  const selectedAddonInputs = Array.from(
    document.querySelectorAll<HTMLInputElement>('.variant-addon-container input[data-variant-addon-option="true"]:checked')
  ).filter((input) => input.value !== 'null' && input.dataset.variantId);

  const kitGroupId = `kit-${Date.now()}`;
  const kitDiscountCents = kitCard.dataset.kitDiscount;
  const mainProperties: Record<string, string> = { _kit_group: kitGroupId, _kit_main: '1' };
  if (kitDiscountCents && parseInt(kitDiscountCents, 10) > 0) {
    mainProperties._kit_discount = kitDiscountCents;
  }
  const items: { id: string | undefined; quantity: number; properties: Record<string, string> }[] = [];
  if (mainVariantId) items.push({ id: mainVariantId, quantity: 1, properties: mainProperties });
  if (product1VariantId) items.push({ id: product1VariantId, quantity: 1, properties: { _kit_group: kitGroupId } });
  if (product2VariantId) items.push({ id: product2VariantId, quantity: 1, properties: { _kit_group: kitGroupId } });
  if (product3VariantId) items.push({ id: product3VariantId, quantity: 1, properties: { _kit_group: kitGroupId } });
  selectedAddonInputs.forEach((input) => {
    items.push({ id: input.dataset.variantId, quantity: 1, properties: { _kit_group: kitGroupId } });
  });

  const fetchConfigFn = window.fetchConfig;
  if (!fetchConfigFn) return;

  const config = fetchConfigFn('javascript');
  (config.headers as Record<string, string>)['Content-Type'] = 'application/json';

  const requestBody: Record<string, unknown> = { items };
  if (cart) {
    const sectionsToRender = (cart as any).getSectionsToRender?.() ?? [
      { section: 'cart-drawer-optimized-v2', selector: '.drawer__inner' },
    ];
    requestBody.sections = sectionsToRender.map((s: any) => s.section ?? s.id);
    requestBody.sections_url = window.location.pathname;
    (cart as any).setActiveElement?.(document.activeElement);
  }
  (config as any).body = JSON.stringify(requestBody);

  const cartAddUrl = window.routes?.cart_add_url;
  if (!cartAddUrl) return;
  const cartAddJsonUrl = cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;

  fetch(cartAddJsonUrl, config as any)
    .then((r) => r.json())
    .then((response) => {
      const pubSubEvents = window.PUB_SUB_EVENTS as any;
      if (response.status) {
        window.publish?.(pubSubEvents?.cartError, {
          source: 'product-form',
          productVariantId: mainVariantId,
          errors: response.errors || response.description,
          message: response.message,
        });
        return;
      }
      if (!cart) {
        const cartUrl = window.routes?.cart_url;
        if (cartUrl) window.location = cartUrl as any;
        return;
      }
      window.publish?.(pubSubEvents?.cartUpdate, {
        source: 'product-form',
        productVariantId: mainVariantId,
        cartData: response,
      });
      customElements.whenDefined(cart.tagName.toLowerCase()).then(() => {
        (cart as any).renderContents?.(response);
      });
    })
    .catch((e) => console.error('[kit-group] kit ATC error:', e))
    .finally(() => {
      submitButton.classList.remove('loading');
      if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
      submitButton.removeAttribute('aria-disabled');
      productForm.querySelector<HTMLElement>('.loading__spinner')?.classList.add('hidden');
    });
}

export function initKitAddToCartOverride(): void {
  const attach = (productForm: HTMLElement) => {
    const submitButton = productForm.querySelector<HTMLButtonElement>('[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener('click', (evt: MouseEvent) => {
      const selectedKitRadio = document.querySelector<HTMLInputElement>('.kit-card input[type="radio"]:checked');
      if (!selectedKitRadio || selectedKitRadio.value === 'base') return;

      const kitCard = selectedKitRadio.closest<HTMLElement>('.kit-card');
      if (!kitCard) return;

      evt.preventDefault();

      if (kitCard.dataset.notAvailable === 'true') return;

      doKitAddToCart(evt, kitCard, productForm, submitButton);
    });
  };

  document.querySelectorAll<HTMLElement>('product-form').forEach(attach);

  // Update ATC price and points when a kit radio changes (event delegation)
  document.addEventListener('change', (evt) => {
    const radio = evt.target as HTMLInputElement;
    if (!radio.matches('.kit-card input[type="radio"]')) return;
    const kitCard = radio.closest<HTMLElement>('.kit-card');
    if (!kitCard) return;
    const price = parseInt(kitCard.dataset.kitPrice ?? '0', 10);
    if (price) updateKitPriceDisplay(price + getSelectedAddonPrice());
  });

  // Update kit card prices and ATC button when an addon is selected/deselected
  document.addEventListener('change', (evt) => {
    const input = evt.target as HTMLInputElement;
    if (!input.matches('.variant-addon-container input[data-variant-addon-option="true"]')) return;
    updateAllKitCardPrices();
    const checkedKitRadio = document.querySelector<HTMLInputElement>('.kit-card input[type="radio"]:checked');
    if (checkedKitRadio && checkedKitRadio.value !== 'base') {
      const kitCard = checkedKitRadio.closest<HTMLElement>('.kit-card');
      if (kitCard) {
        const price = parseInt(kitCard.dataset.kitPrice ?? '0', 10);
        if (price) updateKitPriceDisplay(price + getSelectedAddonPrice());
      }
    }
  });

  // Expose so product-variant.ts can trigger an update after kits are re-rendered
  (window as any).__updateKitAtcPrice = () => {
    updateFromCheckedKitRadio();
    updateAllKitCardPrices();
  };

  // Sync price and points with the pre-checked kit on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateFromCheckedKitRadio();
      updateAllKitCardPrices();
    });
  } else {
    updateFromCheckedKitRadio();
    updateAllKitCardPrices();
  }
}
